<template>
  <div class="container pb-8">
    <div class="breadcrumbs flex flex-wrap py-4">
      <button @click="resetFilter">{{ $t('architecture') }}:</button>
      <button
        v-for="category in categories"
        :key="category"
        @click="toggleFilter(category)"
        :class="{ 'active-filter': filteredCategories.includes(category) }"
        class="category text-gray-500 mx-1 "
      >
        {{ $t(category) }}
      </button>
    </div>
    <div class="grid md:grid-cols-3 gap-4">
      <nuxt-link
        v-for="project in projects"
        :key="project.slug"
        :to="
          localePath({
            name: 'architecture-slug',
            params: { slug: project.slug }
          })
        "
        :class="{ filtered: isFiltered(project) }"
        class="project w-full"
      >
        <div class="project-thumb">
          <img
            :src="'/img/' + project.slug + '/gallery (1).jpg'"
            loading="lazy"
          />
          <div class="project-info text-white font-normal">
            <h3 class="font-normal text-center text-base">
              {{ project.name }}
            </h3>
          </div>
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import projects from '~/static/json/projects.json'

const categories = new Set(projects.map((project) => project.category))

export default {
  data() {
    return {
      projects,
      filteredCategories: [],
      categories
    }
  },
  methods: {
    isFiltered(project) {
      return (
        this.filteredCategories.length === 0 ||
        this.filteredCategories.includes(project.category)
      )
    },
    toggleFilter(category) {
      const index = this.filteredCategories.indexOf(category)

      if (index === -1) {
        this.filteredCategories.push(category)
      } else {
        this.filteredCategories.splice(index, 1)
      }
    },
    resetFilter() {
      this.filteredCategories = []
    }
  }
}
</script>

<style>
.project-thumb {
  height: 250px;
  position: relative;
  overflow: hidden;
  cursor: hover;
}
.project-thumb img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  cursor: hover;
  filter: grayscale(90%);
  transition: 0.6s;
}

.filtered .project-thumb img {
  filter: none;
}
/* .project:nth-child(odd) .project-info {
  background-color: rgba(255, 191, 0, 0.75);
  color: white;
  border-top: none;
} */
.project-thumb:hover .project-info {
  opacity: 1;
}

.project-thumb:hover img {
  transition: 0.4s;
  transform: scale(1.25);
}
.project-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px;
  transition: 0.3s;
  /* border-top: 3px solid black; */
  cursor: hover;
}

.project-info h3 {
  font-weight: 400;
  opacity: 0;
  transition: 0.7s;
}

.filtered .project-info h3 {
  opacity: 1;
}

.active-filter {
  color: black;
}

.category:focus {
  outline: none;
}
</style>
